export enum WebsocketClientEvent {
    TEST_FLOW_RUN_STARTED = 'TEST_FLOW_RUN_STARTED',
    ASK_COPILOT_FINISHED = 'ASK_COPILOT_FINISHED',
    TEST_STEP_FINISHED = 'TEST_STEP_FINISHED',
    REFRESH_PIECE = 'REFRESH_PIECE',
    FLOW_RUN_PROGRESS = 'FLOW_RUN_PROGRESS',
    GENERATE_FLOW_FINISHED = 'GENERATE_FLOW_FINISHED',
    AI_BUILDER_PROGRESS = 'AI_BUILDER_PROGRESS',
    AI_BUILDER_FLOW_PARTIAL_UPDATE = 'AI_BUILDER_FLOW_PARTIAL_UPDATE',
    AI_BUILDER_NARRATION = 'AI_BUILDER_NARRATION',
}

export enum WebsocketServerEvent {
    TEST_STEP_RUN = 'TEST_STEP_RUN',
    ASK_COPILOT = 'ASK_COPILOT',
    TEST_FLOW_RUN = 'TEST_FLOW_RUN',
    GENERATE_FLOW = 'GENERATE_FLOW',
    /** The client's refreshed access token, applied to the live connection */
    AUTH_REFRESH = 'AUTH_REFRESH',
}